import { ApiResponseCode } from '@/constants';

export class ApiError extends Error {
  code: ApiResponseCode;

  constructor(code: ApiResponseCode, message: string) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
  }
}

export const isApiError = (error: unknown): error is ApiError => {
  return (
    error instanceof ApiError &&
    typeof error.code === 'string' &&
    typeof error.message === 'string'
  );
};
